import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Legal.css';

const TermsPage: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className="legal-page">
            <button onClick={() => navigate(-1)} className="legal-page__back-btn">← Geri Dön</button>

            <h1>FASHLYTIC KULLANICI SÖZLEŞMESİ VE KULLANIM KOŞULLARI</h1>

            <h2>1. Hizmetin Tanımı</h2>
            <p>Fashlytic, yapay zeka (AI) teknolojileri kullanarak kullanıcıların dijital ortamda kıyafet denemesini sağlayan bir teknoloji platformudur.</p>

            <h2>2. Yapay Zeka Sonuçları</h2>
            <p>Üretilen görseller ve videolar yapay zeka tahminlerine dayanır. Oluşturulan görüntülerdeki (fit, renk, doku) ile fiziksel ürünler arasında %100 birebir eşleşme garanti edilmez. Görüntüler simülasyon amaçlıdır.</p>

            <h2>3. Kullanıcı Sorumluluğu</h2>
            <ul>
                <li>Kullanıcı, sisteme yüklediği fotoğrafların kendisine ait olduğunu veya fotoğraftaki kişinin açık rızasına sahip olduğunu beyan eder.</li>
                <li>Başkasına ait, izinsiz, yasa dışı, genel ahlaka aykırı veya pornografik içerik yüklemek kesinlikle yasaktır. Bu tür durumlarda hukuki sorumluluk tamamen kullanıcıya aittir.</li>
            </ul>

            <h2>4. Fikri Mülkiyet</h2>
            <p>Fashlytic tarafından üretilen yapay zeka görsellerinin ticari olmayan kullanım hakkı kullanıcıya aittir. Şirket, oluşturulan anonimleştirilmiş görselleri (yüz verisi olmadan) algoritma eğitimi için kullanma hakkını saklı tutar.</p>
        </div>
    );
};

export default TermsPage;
